import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Snackbar,
  Alert,
} from "@mui/material";
import httpRequest from "../utils/httpRequest";

const Supplier = ({ setSuppliers }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [newSupplier, setNewSupplier] = useState({
    name: "",
    gst_number: "",
    account_number: "",
    contact: "",
    address: "",
    email: "",
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const data = await httpRequest("suppliers/getAll", "GET");
        setSuppliers(data);
      } catch (err) {
      } finally {
      }
    };

    fetchSuppliers();
  }, []);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChange = (e) => {
    setNewSupplier({
      ...newSupplier,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      await httpRequest("suppliers/addSupplier", "POST", newSupplier);
      const updatedSuppliers = await httpRequest("suppliers/getAll", "GET");
      setSuppliers(updatedSuppliers);
      setSnackbar({
        open: true,
        message: "Supplier added successfully!",
        severity: "success",
      });
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.response?.data?.error || "Failed to add supplier",
        severity: "error",
      });
    } finally {
      setOpenDialog(false);
      setNewSupplier({
        name: "",
        gst_number: "",
        contact: "",
        address: "",
        email: "",
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpenDialog}
        sx={{ marginBottom: 2 }}
      >
        Add Supplier
      </Button>

      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Add New Supplier</DialogTitle>
        <DialogContent>
          <TextField
            label="Name"
            name="name"
            value={newSupplier.name}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Unique Account Number"
            name="account_number"
            value={newSupplier.account_number}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="GST Number"
            name="gst_number"
            value={newSupplier.gst_number}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Contact"
            name="contact"
            value={newSupplier.contact}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Address"
            name="address"
            value={newSupplier.address}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Email"
            name="email"
            value={newSupplier.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Supplier;